import { userResetPassword } from "../../../helpers/backend_helper";
import {
  resetPasswordSuccess,
  resetPasswordError,
  loadingData,
} from "./reducer";

export const resetPassword = (values) => async (dispatch) => {
  try {
    dispatch(loadingData(true));
    const response = await userResetPassword(values);
    const data = response;
    dispatch(resetPasswordSuccess(data));
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(resetPasswordError(errorMessage));
  } finally {
    dispatch(loadingData(false));
  }
};
